import styled from 'styled-components';
import { shadows } from 'tokens';

export const ColorSwatch = styled.div<{ color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 4px;
	background: ${({ color }) => color};
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const ColorPickerPopover = styled.div`
	position: absolute;
	bottom: 40px;
	right: 0;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	box-shadow: ${shadows.md};
	padding: 12px;
	z-index: 1;
`;
